import entriesList from './generic/entries-list'
import { flatten, sortBy } from 'lodash'
import marketplacePartnerships from '@/services/marketplace-partnerships'

export const state = () => ({
  ...entriesList.getState(),
})

export const mutations = {
  ...entriesList.getMutations(),
}

export const actions = {
  async remove({ commit }, { id }) {
    await marketplacePartnerships.removePartnership({ id })
    commit('remove', { entryId: id })
  },
  setOrder({ commit }, { partnerships }) {
    commit('setEntries', {
      entries: partnerships,
      totalCount: partnerships.length,
    })
  },
  ...entriesList.getActions({
    getQueryUrl: ({ params }) => `/marketplace/partnerships`,
    getAddUrl: (entry) => `/marketplace/partnerships/create`,
    getUpdateUrl: (entry) => `/marketplace/partnerships/${entry.id}/update`,
  }),
}

export const getters = {
  allTags: (state) => {
    const tagsWithRepeats = flatten(state.entries.map((p) => p.tags || []))
    const tagsWithoutRepeats = new Set(tagsWithRepeats)
    return Array.from(tagsWithoutRepeats)
  },
  tags: (state, getters) => {
    return sortBy(getters.allTags, (t) => t.toLowerCase())
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
